import downloadStatementController from './download-statement';

export default function (app) {
	app.component('downloadStatement', {
		transclude: true,
		bindings: {
			goToWelcomePageFunction: '&'
		},
		templateUrl: 'common/download-statement',
		controller: [downloadStatementController]
	});
};
